export default function cleanPath(url: string): string {
  const firstSlash = url.indexOf('/');
  const relativeUrl = url.substr(firstSlash + 1);
  const cleaned = relativeUrl.substr(-1) === '/' ? relativeUrl.substr(0, relativeUrl.length - 1) : relativeUrl;
  return cleaned;
}
